<template>
    <div class="filters">
        <div class="d-md-none filter-open" :class="{ 'is-open': filterOpen }"  @click="toggleFilterOpen">
            FILTER VIEW <div class="icon icon--inline icon--arrow-down"></div>
        </div>
        <div class="max-container filters-wrapper" :class="{ 'is-open': filterOpen }" >
            <div class="d-md-flex">
                <select-input
                    class="source-filter filter"
                    placeholder="Media Sources"
                    :options="mediaSources"
                    @input="updateSource"
                    :value="globalSource"
                    :searchable="false"
                    inputId="source"
                >
                </select-input>
                <div class="date-filters">
                    <date-input placeholder="Select from date" class="filter" @input="updateFromDate" :disabled="fromDisabled()" :val="fromDate" inputId="fromDate"></date-input>
                    <date-input placeholder="Select to date" class="filter" @input="updateToDate" :disabled="toDisabled()" :val="toDate" inputId="toDate"></date-input>
                </div>
                <select-input
                    class="platform-filter d-md-none"
                    placeholder="Choose Platform"
                    :options="tabChoices"
                    @input="updateCurrentTab"
                    :value="currentTabFormatted"
                    :searchable="false"
                    inputId="tab"
                >
                </select-input>
                <div class="reset-buttons">
                    <button @click="reset" class="reset-button">Reset</button>
                </div>
            </div>
        </div>
        <div class="max-container d-none d-md-block">
            <div class="d-md-flex">
                <div class="tab font-arial text-center" :class="{ active: currentTab === 'media' }" @click="updateCurrentTab('media')">Media</div>
                <div class="tab font-arial text-center" :class="{ active: currentTab === 'website' }" @click="updateCurrentTab('website')">Website</div>
            </div>
        </div>
    </div>
</template>

<script>
    import store from '@/store';
    import DateInput from '@/components/filters/DateInput';
    import SelectInput from '@/components/filters/SelectInput';

    export default {
        components: {
            DateInput,
            SelectInput,
        },
        data() {
            return {
                filterOpen: false,
            };
        },
        computed: {
            currentTabFormatted() {
                const text = store.state.currentTab;
                return text.replace(text[0], text[0].toUpperCase());
            },
            currentTab() {
                return store.state.currentTab;
            },
            fromDate() {
                return store.state.globalFilters.fromDate;
            },
            toDate() {
                return store.state.globalFilters.toDate;
            },
            tabChoices() {
                return [
                    { label: 'Media', value: 'media' },
                    { label: 'Website', value: 'website' },
                ];
            },
            globalSource() {
                return store.state.globalSource;
            },
            mediaSources() {
                const initial = [
                    {
                        label: 'All',
                        value: 'All',
                    },
                ];

                const sources = store.state.mediaSources.sources;

                if (sources) {
                    sources.forEach((e) => {
                        const optionObj = {
                            label: e.source_name,
                            value: e.source_value,
                        };

                        initial.push(optionObj);
                    });
                }

                return initial;
            },
        },
        methods: {
            toggleFilterOpen() {
                this.filterOpen = !this.filterOpen;
            },
            reset() {
                const resets = [];

                resets.push(
                    store.dispatch('updateGlobalFilters', {
                        name: 'fromDate',
                        value: null,
                    }),
                );

                resets.push(
                    store.dispatch('updateGlobalFilters', {
                        name: 'toDate',
                        value: null,
                    }),
                );

                resets.push(
                    store.dispatch('updateGlobalFilters', {
                        name: 'source',
                        value: 'All',
                    }),
                );

                Promise.all(resets).then(() => store.dispatch('refreshAllData'));
            },
            fromDisabled() {
                if (store.state.chartData.campaignStartDate) {
                    const startDate = new Date(store.state.chartData.campaignStartDate);

                    return {
                        to: startDate,
                    };
                }

                return {};
            },
            toDisabled() {
                if (store.state.chartData.campaignStartDate) {
                    const endDate = new Date(store.state.chartData.campaignEndDate);
                    endDate.setDate(endDate.getDate() + 1);

                    return {
                        from: endDate,
                    };
                }

                return {};
            },
            updateSource(value) {
                store.dispatch('updateGlobalSource', this.mediaSources.map(o => o.value === value).source);

                store.dispatch('updateGlobalFilters', {
                    name: 'source',
                    value,
                }).then(() => store.dispatch('refreshAllData'));
            },
            updateFromDate(value) {
                store.dispatch('updateGlobalFilters', {
                    name: 'fromDate',
                    value,
                }).then(() => store.dispatch('refreshAllData'));
            },
            updateToDate(value) {
                store.dispatch('updateGlobalFilters', {
                    name: 'toDate',
                    value,
                }).then(() => store.dispatch('refreshAllData'));
            },
            updateCurrentTab(newValue) {
                let value = newValue;

                if (newValue === null) {
                    value = 'Media';
                }

                store.dispatch('updateCurrentTab', {
                    value: value.toLowerCase(),
                });
            },
        },
    };
</script>

<style lang="scss" scoped>
    @import '../assets/scss/partials/variables';
    @import '../assets/scss/partials/mixins';

    .filter-open {
        position: absolute;
        bottom: 100%;
        left: 50%;
        transform: translateX(-50%);

        width: 170px;

        padding: 12px 14px 14px 17px;

        background-color: $ocean-blue;

        color: white;

        @include fontArial();

        .icon {
            margin-left: 14px;
            transition: transform 0.5s ease;
        }

        &.is-open {
            .icon {
                transform: rotate(-180deg);
            }
        }
    }

    .filters {
        position: relative;
        background-color: $ocean-blue;

        @media screen and (min-width: $tablet) {
            padding-top: 40px;
        }
    }

    .filters-wrapper {
        max-height: 0;

        overflow: hidden;
        transition-property: max-height, padding-top, padding-bottom;
        transition-duration: 0.5s;
        transition-timing-function: ease;

        &.is-open {
            height: auto;
            max-height: 274px;

            padding-top: 30px;
            padding-bottom: 35px;
        }

        @media screen and (min-width: $tablet) {
            height: auto;
            max-height: none;
            overflow: visible;

            &.is-open {
                padding-top: 0;
                padding-bottom: 0;
            }
        }
    }

    .source-filter,
    .date-filters,
    .platform-filter {
        margin-bottom: 20px;
    }

    .source-filter,
    .date-filters,
    .reset-buttons {
        @media screen and (min-width: $tablet) {
            margin-bottom: 47px;
        }
    }

    .source-filter {
        @media screen and (min-width: $tablet) {
            margin-right: 20px;
            flex-basis: 156px;
        }
    }

    .date-filters {
        position: relative;
        display: flex;

        .filter {
            flex-shrink: 1;
            flex-basis: 48%;
            flex-grow: 1;

            @media screen and (min-width: $tablet) {
                flex-basis: auto;
                flex-shrink: 0;
                flex-grow: 0;

                margin-right: 20px;
            }

            &:nth-child(1) {
                margin-right: 5px;

                @media screen and (min-width: $tablet) {
                    margin-right: 20px;
                }
            }
        }
    }

    .reset-buttons {
        position: relative;
    }

    .reset-button {
        width: 100%;
        height: 100%;
        padding: 12px 0 11px 10px;

        background-color: $kpmg-blue;
        color: white;
        font-size: 12px;
        letter-spacing: 0.6px;
        cursor: pointer;

        @media screen and (min-width: $tablet) {
            margin-left: 3px;
            padding: 11px 20px 10px;
        }
    }

    .tab {
        flex-basis: 241px;
        padding: 0;

        color: white;
        font-size: 16px;
        letter-spacing: 0.05625em;

        background-color: rgba(255,255,255,0.25);

        cursor: pointer;

        transition: background-color 0.5s ease;

        @media screen and (min-width: $tablet) {
            padding: 17px 0 16px;
            margin-right: 5px;
        }

        &.active {
            color: $kpmg-blue;
            background-color: $light-grey;
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/FiltersContainer.vue